import { Flex } from 'antd';

import { useSingleGraphReferenceContext } from 'business/providers/graph-reference';
import { IndicatorAnalyzeExportButton } from 'business/shift-report/indicators/pages/indicator-analyze/components/export-button';
import { handlePrintWithChart } from 'technical/handle-print-with-chart';
import { PrintButton } from 'ui/button/print-button';

export const IndicatorAnalyzeHeader = () => {
  const { ref } = useSingleGraphReferenceContext();
  return (
    <Flex gap={4} justify="flex-end" align="center">
      <PrintButton onClick={() => handlePrintWithChart(ref)} />
      <IndicatorAnalyzeExportButton />
    </Flex>
  );
};
